export const COOKIE_DURATION = {
  MONTH: 60 * 60 * 24 * 30,
  YEAR: 60 * 60 * 24 * 365,
}

export const cookieOpts = (maxAge, { secure = false } = {}) => ({
  path: '/',
  maxAge,
  sameSite: 'lax',
  ...(secure && { secure: true }),
})
